<template>
  <div class="card card-bg shadow rounded-3 border-1 icon-cards">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center p-3 icon-container">
          <i :class="'fa-2x text-primary ' + icon_class"></i>
        </div>
        <div class="text-end text-content mt-2">
          <h4 v-if="count !== null && count !== ''" class="mb-0">{{ count }}</h4>
          <span v-else-if="show_button">
            <button
              class="btn bg-green rounded-3 fw-bold btn-sm text-xxs text-white"
            >
              View
            </button>
          </span>
          <p class="text-xs subtext">{{ title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IconCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    count: {
      type: [String, Number],
      default: null,
    },
    icon_class: {
      type: String,
      required: true,
    },
    show_button: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>

<style scoped>
.icon-container {
  margin-right: 15px;
  padding: 10px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease;
}

.text-content h4 {
  font-weight: bold;
}

.text-content .subtext {
  font-size: 0.85rem;
  margin-top: 5px;
}
</style>
